import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';
import AssetsPage from 'components/assets/page/AssetsPage';
export default function ManageAssetsActionImpl(){

    return (
        <>
        <AssetsPage/>
        </>
    )
}